'use es6';

export const INPUT_DEBOUNCE_DELAY = 250;